import React from 'react'
import classNames from 'classnames'

export default function HeaderWithSelect (props) {

  return (
    <div className={classNames('header-with-select', {
      'header-with-select--no-border' : props.noBorder
    })}>
      <div className="header-with-select__inner">
        <div className="header-with-select__text-container">
          {props.title && (
            <h2 className="header-with-select__title dm-title">{props.title}</h2>
          )}
          {props.text && (
            <div className="header-with-select__text dm-wysiwyg dm-wysiwyg--fs14 dm-wysiwyg--darkgrey" dangerouslySetInnerHTML={{ __html: props.text }} />
          )}
        </div>
        {props.selectOptions && (
          <div className="header-with-select__select-container select-container">
            <label htmlFor="">{props.label}</label>
            <select name="" id="" className="dm-select" onChange={props.onSelectChange}>
              {props.selectOptions.map((option, i) => {
                return (<option key={i} value={option.value}>{option.text}</option>)
              })}
            </select>
          </div>
        )}
      </div>
    </div>
  )
}